import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
};
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 14
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.28,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-110" data-mp="3binq6vuc68md">
      {children}
    </motion.div>;
}